const appConfig = {
  // apiPrefix: "https://vm-sales-android-api.onrender.com/api/v1/web",
  // apiPrefix: "http://localhost:5002/api/v1/web",https://gagangiri.5techg.com/api/
  apiPrefix: "https://gagangiri.5techg.com/api/v1/web",
  authenticatedEntryPath: "/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/",
  locale: "en",
  enableMock: true,
};

export default appConfig;
